<template>
  <div id="product-search-page">
    <v-container fluid grid-list-xl mt-5>
      <!-- Product -->
      <ProductBox :rawDataText="rawDatas[0] ? rawDatas[0].rawDataText : ''" />

      <!-- Content -->
      <v-layout align-center justify-center row wrap>
        <v-flex :key="productContent.idx" sm6 v-for="productContent in productContents" xs11>
          <!-- <div class="title font-THSarabunNew my-4">{{ productContent.title }}</div> -->
          <div class="font-THSarabunNew" v-html="productContent.content"></div>
        </v-flex>
      </v-layout>
      <!-- Variety -->
      <VarietyBox class="mt-3" />

      <v-layout align-center justify-center row wrap>
        <v-flex mb-2 xs11>
          <div class="font-THSarabunNew" v-html="rawDatas[1].rawDataText" v-if="rawDatas[1]"></div>
        </v-flex>
      </v-layout>

      <!-- Parts -->
      <PartsBox />

      <!-- Properties -->
      <PropertiesBox />

      <!-- Workflow -->
      <WorkflowBox class="mt-3" />

      <!-- Content Searchbox -->
      <v-layout align-center justify-center mt-4 row wrap>
        <v-flex text-xs-center xs11>
          <base-search-bottom-page></base-search-bottom-page>
        </v-flex>
      </v-layout>

      <!-- Banners -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs11>
          <base-banners bannerPositionId="BANNERPOS0000001" pageId="PAGES0000002"></base-banners>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import ProductBox from '../components/product_search/ProductBox'
import VarietyBox from '../components/product_search/VarietyBox'
import PartsBox from '../components/product_search/PartsBox'
import PropertiesBox from '../components/product_search/PropertiesBox'
import WorkflowBox from '../components/product_search/WorkflowBox'
export default {
  name: 'product-search-page',
  components: {
    ProductBox,
    VarietyBox,
    PartsBox,
    PropertiesBox,
    WorkflowBox
  },
  data() {
    return {
      productContents: []
    }
  },
  computed: {
    rawDatas() {
      return _.shuffle(this.$store.state.RawData.data)
    },
    productId() {
      return window.atob(this.$route.params.productId)
    }
  },
  created() {
    this.$store.dispatch('RawData/fetch', this.productId)
    this.fetchProductContent()
  },
  methods: {
    async fetchProductContent() {
      try {
        const response = await this.axios.get(`portal/product_content/${this.productId}`)
        this.productContents = response.data
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss">
#product-search-page {
  img {
    width: 100%;
    height: 100%;
    margin-bottom: 0px;
  }
}
</style>
